import { Flex, Text, Box } from "@chakra-ui/react";
import { SEND_CONFIG_THEME } from "./theme";

interface SliderHeaderProps {
  t: (key: React.Key) => string;
  title: string;
  subtitle?: string;
  selectedValue: string;
  hideSelectedValue?: boolean;
}

/**
 * Reusable header component for sliders
 * Displays title, optional subtitle, and selected value
 */
export function SliderHeader({
  t,
  title,
  subtitle,
  selectedValue,
  hideSelectedValue = false,
}: SliderHeaderProps) {
  return (
    <Flex
      justifyContent="space-between"
      alignItems={subtitle ? "flex-start" : "center"}
      flexWrap="wrap"
      gap={4}
    >
      <Box>
        <Text
          color={SEND_CONFIG_THEME.colors.textPrimary}
          fontSize={SEND_CONFIG_THEME.fontSize.title}
          fontWeight="medium"
        >
          {title}
        </Text>
        {subtitle && (
          <Text
            color={SEND_CONFIG_THEME.colors.textSecondary}
            fontSize={SEND_CONFIG_THEME.fontSize.subtitle}
          >
            {subtitle}
          </Text>
        )}
      </Box>
      {!hideSelectedValue && (
        <Text
          color={SEND_CONFIG_THEME.colors.primary}
          fontWeight="semibold"
          fontSize={SEND_CONFIG_THEME.fontSize.title}
          ml={4}
          whiteSpace="nowrap"
          cursor="default"
          transition="all 0.2s"
          _hover={{ color: SEND_CONFIG_THEME.colors.primaryHover }}
          aria-label={t("sendConfig.selectedInterval")}
        >
          {selectedValue}
        </Text>
      )}
    </Flex>
  );
}
